import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';

function ProductImpBtn() {
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) return alert('Please select a file');

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/products/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      alert(res.data.message + ' (' + res.data.count + ' rows)');
      setShowModal(false); // close modal
      setFile(null);
    } catch (err) {
      console.error(err);
      alert('Error importing products');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className='btn btn-primary btn-sm me-4' onClick={() => setShowModal(true)}>
        Import Products
      </button>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Import Products</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group controlId="formFile">
              <Form.Label>Select Excel File (.xlsx)</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx"
                onChange={handleFileChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Importing...' : 'Import'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProductImpBtn;
